module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "pa-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('div', [_vm._v("Innacco © " + _vm._s(new Date().getFullYear()))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e30091ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainFooter.vue
// module id = 341
// module chunks = 2